module.exports = new __parcel__URL__("closed-hihat_9.8e0b0ab6.mp3").toString();